import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TagModule } from 'primeng/tag';

// FIXME valutare se inserire il nome businessName dell'azienda
@Component({
  selector: 'app-owner-company-code-tag',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TagModule, RouterModule, NgTemplateOutlet],
  template: `
    @let _size = size();
    @let _clickable = clickable();

    @if (_clickable) {
      <a [routerLink]="'/owner-company'" (click)="onClick($event)">
        <ng-container [ngTemplateOutlet]="tag" />
      </a>
    } @else {
      <ng-container [ngTemplateOutlet]="tag" />
    }

    <ng-template #tag>
      @let _small = _size === 'small';
      <p-tag class="h-6 w-26">
        <div class="flex items-center gap-1 px-1.5 whitespace-nowrap">
          <i [class.!text-3xs]="_small" [class.!text-2xs]="!_small" class="pi pi-briefcase"></i>
          <span [class]="_size === 'small' ? '!text-2xs' : '!text-sm'" class="font-bold" i18n> MyComp </span>
        </div>
      </p-tag>
    </ng-template>
  `,
  styles: [
    `
      .p-tag {
        border: 1px solid var(--color-soe-ocean-blue);
        box-shadow: 2px 1px 0px 0px var(--color-soe-ocean-blue);
        --p-tag-primary-background: var(--color-white);
        padding: 0;
        --p-tag-primary-color: var(--color-black);
      }
    `,
  ],
})
export class OwnerCompanyCodeTagComponent {
  readonly size = input<'small' | 'default'>('default');
  readonly clickable = input<boolean>(true);

  onClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
  }
}
